var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4612 4.11371C13.4612 3.6892 13.4409 3.26469 13.4409 2.88061C13.4409 2.57738 13.1984 2.31459 12.8749 2.31459C10.4896 2.31459 8.65004 1.62729 7.13393 0.151611C6.91157 -0.050537 6.56792 -0.050537 6.34556 0.151611C4.82945 1.62729 3.01012 2.31459 0.604559 2.31459C0.301337 2.31459 0.0385447 2.55717 0.0385447 2.88061C0.0385447 3.2849 0.038545 3.6892 0.0183302 4.11371C-0.0625289 8.13645 -0.163604 13.6349 6.5477 15.9596C6.60835 15.9798 6.66899 16 6.72964 16C6.79028 16 6.85093 15.9798 6.91157 15.9596C13.6229 13.6349 13.5218 8.13645 13.4612 4.11371ZM6.74985 14.8478C1.00885 12.7656 1.08971 8.17688 1.17057 4.15414C1.17057 3.91156 1.17057 3.66898 1.19079 3.44662C3.43463 3.34555 5.23374 2.67846 6.77007 1.34428C8.30639 2.67846 10.1055 3.36576 12.3493 3.44662C12.3493 3.66898 12.3493 3.91156 12.3696 4.15414C12.41 8.17688 12.4908 12.7454 6.74985 14.8478Z",
    fill: "#333333",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66998 6.05447L5.98141 8.74303L4.82917 7.59079C4.60681 7.36843 4.26316 7.36843 4.0408 7.59079C3.81843 7.81315 3.81843 8.1568 4.0408 8.37917L5.59733 9.9357C5.69841 10.0368 5.83991 10.0974 6.00163 10.0974C6.14313 10.0974 6.28464 10.0368 6.40592 9.9357L9.49879 6.84284C9.72115 6.62048 9.72115 6.27683 9.49879 6.05447C9.25621 5.8321 8.89234 5.8321 8.66998 6.05447Z",
    fill: "#333333",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.9ed90b9cdac8fa8c545ac8f1589064b9.svg";
export { ForwardRef as ReactComponent };